import { orderBy } from "lodash";
import { DataProvider } from "react-admin";
import { getRouteService } from "utils/tools";

export const colors = [
  "#00796B",
  "#E65100",
  "#008000",
  "#4682B4",
  "#9932CC",
  "#00FF00",
  "#FF4500",
  "#40E0D0",
  "#FF69B4",
  "#FF33FF",
  "#FFD700",
  "#2E8B57",
  "#8B008B",
  "#DAA520",
  "#8A2BE2",
  "#20B2AA",
  "#556B2F",
  "#32CD32",
  "#B8860B",
  "#FF6347",
  "#7B68EE",
  "#9370DB",
  "#ADFF2F",
  "#3CB371",
  "#800080",
  "#808000",
  "#2F4F4F",
  "#4B0082",
  "#CD5C5C",
  "#B3B31A",
  "#6495ED",
  "#FF7F50",
  "#48D1CC",
  "#191970",
  "#008B8B",
  "#D2691E",
  "#00FFFF",
  "#FFA07A",
  "#800000",
  "#4169E1",
  "#8B4513",
  "#5F9EA0",
  "#A52A2A",
  "#6A5ACD",
  "#9400D3",
  "#FF8C00",
  "#8FBC8F",
  "#FF1493",
  "#008080",
  "#1E90FF",
  "#9ACD32",
  "#CD853F",
  "#B0E0E6",
  "#66E64D",
  "#BA55D3",
  "#00FA9A",
  "#483D8B",
  "#00CED1",
  "#BDB76B",
  "#8B008B",
  "#87CEEB",
  "#FF4500",
  "#01579B",
  "#1B5E20",
  "#6A1B9A",
  "#B71C1C",
  "#00B8D4",
  "#BF360C",
  "#FF6633",
  "#FFB399",
  "#FFFF99",
  "#00B3E6",
  "#E6B333",
  "#3366E6",
  "#999966",
  "#99FF99",
  "#B34D4D",
  "#80B300",
  "#809900",
  "#E6B3B3",
  "#6680B3",
  "#66991A",
  "#FF99E6",
  "#CCFF1A",
  "#FF1A66",
  "#E6331A",
  "#33FFCC",
  "#66994D",
  "#B366CC",
  "#4D8000",
  "#B33300",
  "#CC80CC",
  "#66664D",
  "#991AFF",
  "#E666FF",
  "#4DB3FF",
  "#1AB399",
  "#E666B3",
  "#33991A",
  "#CC9999",
];

const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));

export const renderRoutePolyline = async (routes: any) => {
  let tempRoutes: any = [];

  await Promise.all(
    routes.map(async (route: any) => {
      await delay(2000);
      const getRoute = await getRoutePolyline(route.routeLocations).then(
        (result) => {
          result.color = route.color;

          return result;
        },
      );

      tempRoutes.push(getRoute);
    }),
  );

  return tempRoutes;
};

const getRoutePolyline = async (locations: any) => {
  try {
    let tempRouteLocations: any = [];
    let routeLocations: any = [];

    await Promise.all(
      locations.map(async (marker: any, index: number) => {
        if (index < locations.length - 1) {
          const start = locations[index];
          const end = locations[index + 1];

          const { routePolyline: routeResults } = await getRouteService(
            start,
            end,
          ).then((result: any) => {
            result.index = index;
            return result;
          });

          tempRouteLocations.push(routeResults);
          const sortedRouteLocationsByIndex = orderBy(
            tempRouteLocations,
            ["index"],
            ["asc"],
          );

          routeLocations = [...routeLocations, ...sortedRouteLocationsByIndex];
        }
      }),
    );

    return routeLocations;
  } catch (e) {
    setTimeout(() => {
      console.log(`GOT ERROR: ${e}, Re-fetch again.`);
      getRoutePolyline(locations);
    }, 3000);
  }
};

// props for tab menu
export const a11yProps = (index: number) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

export const getStudents = async (
  levelId: Number,
  isCcaSchedule: boolean,
  isRegularSchedule: boolean,
  provider: DataProvider,
) => {
  const filter: any = {
    LevelId: levelId,
    Status: "active",
  };

  if (isCcaSchedule) {
    filter.HasCcaSchedule = isCcaSchedule;
  }

  if (isRegularSchedule) {
    filter.HasRegularSchedule = isRegularSchedule;
  }

  return await provider
    .getList("students", {
      filter,
      pagination: {
        page: 1,
        perPage: 9999,
      },
      sort: {
        field: "Id",
        order: "ASC",
      },
    })
    .then((result) => {
      return result.data;
    });
};

export const getStudentAddressesByStudentIds = async (
  studentIds: Number[],
  provider: DataProvider,
) => {
  return await provider
    .getList("studentAddresses", {
      filter: { StudentIds: studentIds },
      pagination: {
        page: 1,
        perPage: 1000,
      },
      sort: {
        field: "Id",
        order: "ASC",
      },
    })
    .then((result) => {
      return result.data;
    });
};

export const getFixedLocationDropOffBySchoolIds = async (
  schoolId: Number,
  provider: DataProvider,
) => {
  return await provider
    .getList("ccaFixedLocationDropOffs", {
      filter: { SchoolId: schoolId, Status: "active" },
      pagination: {
        page: 1,
        perPage: 1000,
      },
      sort: {
        field: "Id",
        order: "ASC",
      },
    })
    .then((result) => {
      return result.data;
    });
};

export const DriversResources = async (
  ids: number[],
  provider: DataProvider,
) => {
  return await provider
    .customGetListWithStaticParams(`drivers?ids=${ids}`)
    .then((result: any) => {
      return result.data;
    });
};

export const BusAssistanResources = async (
  ids: number[],
  provider: DataProvider,
) => {
  return await provider
    .customGetListWithStaticParams(`busAssistants?ids=${ids}`)
    .then((result: any) => {
      return result.data;
    });
};

export const VehiclesResources = async (
  ids: number[],
  provider: DataProvider,
) => {
  return await provider
    .customGetListWithStaticParams(`vehicles?ids=${ids}`)
    .then((result: any) => {
      return result.data;
    });
};

export const LevelsResources = async (
  ids: number[],
  provider: DataProvider,
) => {
  return await provider
    .customGetListWithStaticParams(`levels?ids=${ids}`)
    .then((result: any) => {
      return result.data;
    });
};
